<template>
  <div class="checkmark-callouts-dark px-2 grid grid-cols-[auto_auto] gap-y-2.5 justify-between text-xs">
    <CheckmarkCallout
      :text="$t('bundler.savings_off_first_order', { firstSavings: displayFirstSavings })"
    />
    <CheckmarkCallout
      :text="$t('bundler.savings_off_future_orders', { savings: store.pricing.savings })"
    />
    <CheckmarkCallout
      :text="$t('bundler.free_flavor_with_every_box')"
    />
    <CheckmarkCallout :text="$t('bundler.cancel_anytime')" />
    <CheckmarkCallout :text="$t('bundler.free_shipping_in_the_usa')" />
    <CheckmarkCallout :text="$t('bundler.money_back_guarantee')" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useBundleStore, useReferralStore } from '@/stores'
import { calculateReferralSavings } from '@/utils'
import { CheckmarkCallout } from '@oatsovernight/storybook'

const store = useBundleStore()
const referralStore = useReferralStore()
const { hasReferral, discountCents } = storeToRefs(referralStore)

const displayFirstSavings = computed(() => {
  if (!hasReferral.value || !store.pricing) return store.pricing.firstSavings
  
  const savingsAmount = calculateReferralSavings(store.pricing.onetimeCents, store.pricing.minCents, discountCents.value)
  return `$${savingsAmount}`
})
</script>
